import React from "react";
import Modal from "react-modal";
import { ReactComponent as LeftArrow } from "../../assets/icons/nav/arrowleft.svg";
import "./help.css";

import {
	Accordion,
	AccordionItem,
	AccordionItemHeading,
	AccordionItemButton,
	AccordionItemPanel,
} from "react-accessible-accordion";

// Demo styles, see 'Styles' section below for some notes on use.
import "react-accessible-accordion/dist/fancy-example.css";
class Help extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
			helpText: [],
		};
		this.handleClick = this.handleClick.bind(this);
		this.closeModal = this.closeModal.bind(this);
	}
	componentDidMount() {
		const STRAPI_URL = process.env.REACT_APP_STRAPI_URL;
		fetch(STRAPI_URL + "/mediacontents")
			.then((res) => res.json())
			.then((result) => {
				const filtered = result.filter((result) => result.relatedPage === 1);
				this.setState({
					helpText: filtered,
				});
			});
	}
	handleClick() {
		this.setState({ showModal: true });
	}
	closeModal() {
		this.setState({ showModal: false });
	}
	render() {
		return (
			<>
				<button
					id="helpButton"
					aria-label="help"
					title="help"
					onClick={this.handleClick}
				>
					?
				</button>
				<Modal
					closeTimeoutMS={2000}
					className="Modal"
					ariaHideApp={false}
					isOpen={this.state.showModal}
					onAfterOpen={this.afterOpenModal}
					onRequestClose={this.closeModal}
				>
					<div className="modalNavigation">
						<button className="closeModalButton" onClick={this.closeModal}>
							<LeftArrow />{" "}
						</button>
					</div>
					<Accordion className="helpAccordion" allowZeroExpanded>
						{this.state.helpText.map((help) => (
							<AccordionItem key={help.id}>
								<AccordionItemHeading>
									<AccordionItemButton>{help.Title}</AccordionItemButton>
								</AccordionItemHeading>
								<AccordionItemPanel>
									<p>{help.textContent}</p>
								</AccordionItemPanel>
							</AccordionItem>
						))}
					</Accordion>
				</Modal>
			</>
		);
	}
}

export default Help;
